import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import { CoinBalanceTopUp } from '@components/CoinBalanceTopUp/CoinBalanceTopUp';
import { H1 } from '@components/Typography/Typography';
import { selectCoinDepositList } from '@redux/selectors/userSelectors';
import { useAppSelector } from '@redux/store';

import { type TgemPurchaseSource } from '@/common/types/modal';
import { OffersList } from '@/components/CoinMarket/OffersList/OffersList';
import { Close } from '@/components/ui/Close/Close';

import { ModalContext } from '../Modal/config';

// The App Store build sells T-Gems through Apple, not Telegram Stars
const isNativeApp = Capacitor.isNativePlatform();

interface CoinDepositProps {
  source: TgemPurchaseSource;
}

const CoinDeposit: FC<CoinDepositProps> = ({ source }) => {
  const { closeModal, secondModal } = useContext(ModalContext);
  const { list } = useAppSelector(selectCoinDepositList);
  const { t } = useTranslation();

  return (
    <div className="w-full h-[100svh] relative flex flex-col items-center gap-[40px] pt-[150px]">
      <CoinBalanceTopUp
        className="!h-12 !pl-2 !pr-3 py-[0.625rem]"
        contenctClassName="!items-start"
        compare={Infinity}
        iconSize="1.75rem"
      />
      <div className="w-full relative z-[2] isolate flex flex-col items-center">
        <H1 weight="bold" className="mb-5">
          {t(isNativeApp ? 'Buy T-Gems' : 'Buy T-Gems with Stars')}
        </H1>
        <OffersList
          list={list.sort((a, b) => b.coin - a.coin)}
          isModal={true}
          source={source}
        />
      </div>
      <Close
        onClick={() => {
          closeModal();
          secondModal.closeModal();
        }}
        imageVariant="modal"
        size="lg"
        className="absolute bottom-[calc(var(--tg-safe-area-inset-bottom,0px)+1.25rem)] z-[5]"
      />
    </div>
  );
};

export { CoinDeposit };
